import { combineReducers } from 'redux'
import makeItemsReducer from '../items'
import info from './info'
import counts from './counts'
import itemsICanGet from './itemsICanGet'
import {
  GET_OTHER_USER_OWNED_ITEMS,
  GET_OTHER_USER_WANTED_ITEMS,
  GET_OTHER_USER_ITEMS_I_CAN_GIVE,
} from '../../actions'

export default combineReducers({
  info,
  counts,
  itemsICanGet,
  ownedItems: makeItemsReducer(GET_OTHER_USER_OWNED_ITEMS, {
    handleWanted: false,
  }),
  wantedItems: makeItemsReducer(GET_OTHER_USER_WANTED_ITEMS, {
    handleWanted: false,
  }),
  itemsICanGive: makeItemsReducer(GET_OTHER_USER_ITEMS_I_CAN_GIVE, {
    handleWanted: false,
  }),
})



// WEBPACK FOOTER //
// ./src/reducers/otherUser/index.js